export function ConfidenceBadge({ confidence }: { confidence: number }) {
    const confidenceLevel = confidence > 0.8 ? "high" : confidence > 0.5 ? "medium" : "low";

    return (
        <span title={`Confidence ${confidence.toFixed(3)}`} className={`confidence-badge ${confidenceLevel}`}>
            {confidence.toFixed(2)}
        </span>
    );
}
